<div class='estimation-container'>
  <div class='estimation-container__content'>
    <cloud-cost-calculation-tool-configuration-window></cloud-cost-calculation-tool-configuration-window>
    <div class='estimation-container__sidebar'>
      <cloud-cost-calculation-tool-estimation-container></cloud-cost-calculation-tool-estimation-container>
    </div>
  </div>
</div>
